import React, { useMemo } from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { ia } from 'lib/helpers/utility';

import TableRow from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/components/TableRow';
import Typography from 'components/shared/Typography/Typography';

import TableCell from './components/TableCell';
import TableFooter from './components/TableFooter';
import TableHeaderRow from './components/TableHeaderRow';

const ReceiptTable = ({ items, columns, footer }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const visibleColumns = useMemo(() => columns.filter((col) => !col.hide), [columns]);

  const hasItems = useMemo(() => ia(items), [items]);

  return (
    <table className="h-fit w-full table-fixed border-collapse">
      {!isMobile && (
        <colgroup>
          {visibleColumns.map((col, idx) => (
            <col
              key={idx}
              style={{
                minWidth: col.minWidth,
                width: col.width || `${100 / visibleColumns.length}%`
              }}
            />
          ))}
        </colgroup>
      )}
      <thead>
        <TableHeaderRow
          columnDefs={visibleColumns}
          preview={true}
          small
          className="bg-neutral-50"
        />
      </thead>
      <tbody>
        {hasItems ? (
          items.map((item, index) => (
            <TableRow
              key={item.name + index}
              row={item}
              columnDefs={visibleColumns}
              idx={index}
              preview
              small
            />
          ))
        ) : (
          <tr className="h-fit w-fit border-0 border-b border-solid border-neutral-200">
            <TableCell
              colSpan={visibleColumns.length}
              className="items-center"
              bodyClassName="h-20 justify-center items-center">
              <Typography variant="p" size="xs">
                No items found
              </Typography>
            </TableCell>
          </tr>
        )}
      </tbody>
      {!isMobile && ia(items) && footer && (
        <tfoot>
          <TableFooter columnDefs={visibleColumns} rowData={items} />
        </tfoot>
      )}
    </table>
  );
};

export default ReceiptTable;
